import { createAction, props } from '@ngrx/store';
import { FeaturePermissionDto } from '../../../api/models/feature-permission-dto';
import { UserQueryDto } from '../../../api/models/user-query-dto';
import { SupplierListV1 } from 'src/app/api/models';

export enum AuthenticationActionTypes {
  LOGIN = '[AUTH] LOGIN',
  SSO_CALLBACK = '[AUTH] SSO_CALLBACK',
  LOGIN_SUCCESS = '[AUTH] LOGIN_SUCCESS',
  USER_PERMISSIONS = '[AUTH] USER_PERMISSIONS',
  USER_SUPPLIER_V1 = '[AUTH] USER_SUPPLIER_V1',
  LOGIN_FAIL = '[AUTH] LOGIN_FAIL',
  LOGOUT = '[AUTH] LOGOUT',
  NEW_PASSWORD_REQUIRED = '[AUTH] NEW_PASSWORD_REQUIRED',
  USER_PROFILE = '[AUTH] USER_PROFILE',
  TOKEN_REFRESH = '[AUTH] TOKEN_REFRESH',
  MFA_SETUP_REQUIRED = '[AUTH] MFA_SETUP_REQUIRED',
  MFA_VERIFICATION_REQUIRED = '[AUTH] MFA_VERIFICATION_REQUIRED',
}
export interface LoginSuccessPayload {
  token: string;
}

export interface UserPermissionsPayload {
  userPermissions: FeaturePermissionDto[];
}
export interface UserSupplierPayloadV1 {
  supplier: SupplierListV1;
}
export interface UserProfilePayload {
  userProfile: UserQueryDto;
}

export const login = createAction(AuthenticationActionTypes.LOGIN, props<{ username: string; password: string }>());
export const ssoCallback = createAction(AuthenticationActionTypes.SSO_CALLBACK);
export const loginSuccess = createAction(AuthenticationActionTypes.LOGIN_SUCCESS, props<LoginSuccessPayload>());
export const newPasswordRequired = createAction(AuthenticationActionTypes.NEW_PASSWORD_REQUIRED);
export const loginFail = createAction(AuthenticationActionTypes.LOGIN_FAIL, props<{ error: string }>());
export const userPermissions = createAction(
  AuthenticationActionTypes.USER_PERMISSIONS,
  props<UserPermissionsPayload>()
);
export const userSupplierV1 = createAction(AuthenticationActionTypes.USER_SUPPLIER_V1, props<UserSupplierPayloadV1>());
export const userProfile = createAction(AuthenticationActionTypes.USER_PROFILE, props<UserProfilePayload>());
export const logout = createAction(AuthenticationActionTypes.LOGOUT);
export const tokenRefreshSuccess = createAction(AuthenticationActionTypes.TOKEN_REFRESH, props<{ token: string }>());
export const mfaSetupRequired = createAction(AuthenticationActionTypes.MFA_SETUP_REQUIRED);
export const mfaVerificationRequired = createAction(AuthenticationActionTypes.MFA_VERIFICATION_REQUIRED);
